module.exports = __webpack_public_path__ + "assets/img/creative-landing.1c847bfd.png";